import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import {
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from "@angular/router";
import { Subject, takeUntil } from "rxjs";
import { AppGlobals } from "src/app/app.globals";
import { FeatureFlags } from "src/app/interfaces/enums/feature-flag";

import { ActivityLogService } from "src/app/services/activity-log.service";
import { ActivitySection } from "src/app/constants/activity-log";
type ConfigTab = {
  text: string;
  link: string;
  features?: FeatureFlags[];
};

@Component({
    selector: "app-contracts-config",
    imports: [CommonModule, RouterLink, RouterLinkActive, RouterOutlet],
    templateUrl: "./contracts-config.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./contracts-config.component.css"]
})
export class ContractsConfigComponent implements OnInit, OnDestroy {
  private readonly allTabs: ConfigTab[] = [
    {
      text: $localize`:@@typesAndDeadlines:Types & Deadlines`,
      link: "types",
    },
    {
      text: $localize`:@@reviewSettings:Review Settings`,
      link: "review-settings",
      features: [FeatureFlags.AIReview],
    },
    {
      text: $localize`:@@templatesConfig:Templates`,
      link: "templates",
      features: [FeatureFlags.TemplateManagement],
    },
  ];

  tabs: ConfigTab[] = [];

  private $unsubscribe = new Subject<void>();

  constructor(private appGlobals: AppGlobals, private activityLog: ActivityLogService) {}

  ngOnInit(): void {
    this.activityLog.logView({ Section: ActivitySection.CONFIG_CONTRACTS });
    this.appGlobals.$features
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe(() => {
        this.tabs = this.allTabs.filter(
          (tab) =>
            tab.features?.every((feature) => AppGlobals.UserCan(feature)) ?? true
        );
      });
  }

  ngOnDestroy(): void {
    this.$unsubscribe.next();
    this.$unsubscribe.complete();
  }
}
